import { render } from "solid-js/web";
import { registerSW } from "virtual:pwa-register";
import { App } from "@/App.tsx";
import "./soluid.css";
// After soluid: it re-bases soluid's own tokens, so it has to win at equal specificity.
import "@/styles/theme.css";
import "@/styles/app.css";
import "@/styles/editor.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root が見つかりません");

render(() => <App />, root);

const updateServiceWorker = registerSW({
  onNeedRefresh() {
    // Applied on the next reload rather than mid-edit, so no in-progress work is lost.
    window.addEventListener("beforeunload", () => void updateServiceWorker(true), { once: true });
  },
});
